type DownloadAsZipRequest = {
  item_ids: Array<number>
}

export function downloadAsZipRequestMapper(
  itemIds: Array<number>
): DownloadAsZipRequest {
  return {
    item_ids: itemIds
  }
}
